import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import "lightgallery/scss/lightgallery.scss";
import "lightgallery/scss/lg-thumbnail.scss";
import "lightgallery/scss/lg-zoom.scss";

var autoscroll = false;
const skaidres = document.querySelector(".skaidres");
const menu = document.querySelector("body > .menu");
// var modal = false;

function slinkSkaidr(a) {
  updateLinks(a);

  autoscroll = true;
  document.getElementById("s" + a).scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
  setTimeout(() => {
    autoscroll = false;
  }, 500);
}
// }
function updateLinks(a) {
  if (autoscroll) {
    return;
  }
  null !== document.querySelector(".rysk") &&
    document.querySelector(".rysk").classList.remove("rysk");
  null !== document.querySelector(".menu #tl" + a) &&
    document.querySelector(".menu #tl" + a).classList.add("rysk");
}
function load() {
  updateLinks(1);
}
// function updateHistory(curr) {
//   window.location.lasthash = window.location.hash;
//   var ne = window.location;

//   ne.hash = curr;
// }
// function goBack() {
//   uzskuzd();
//   history.back();
// }
// function uzskuzd() {
//   skaidres.style.display = "block";
//   menu.style.display = "flex";
//   uzsklanda.classList.remove("o-0");
//   setTimeout(() => {
//     uzsklanda.style.display = "none";
//     target.style.display = "none";
//     modal = false;
//   }, 100);
// }
// window.onhashchange = function () {
//   if (modal) {
//     uzskuzd();
//   }
// };
// window.onclick = function (a) {
//   a.target == uzsklanda && uzskuzd();
// };

lightGallery(document.getElementById("galerija"), {
  plugins: [lgThumbnail, lgZoom],
  speed: 500,
  // ... other settings
});
function animacijaCall(entry, o) {
  entry.forEach((change) => {
    if (change.isIntersecting) {
      change.target.classList.remove("fade-in-ready");
    }
  });
}
function animacijaSetup() {
  const fadeinai = document.querySelectorAll(".fade-in");
  fadeinai.forEach((v) => {
    v.classList.add("fade-in-ready");
  });

  const animaObserver = new IntersectionObserver(animacijaCall, {
    root: cont,
    threshold: 0.2,
  });
  fadeinai.forEach((v) => {
    animaObserver.observe(v);
  });
}
function navigacijaCall(entry, o) {
  entry.forEach((v) => {
    if (v.isIntersecting) {
      updateLinks(v.target.id[1]);
    }
  });
}
function navigacijaSetup() {
  const skaidres = document.querySelectorAll(".skaidre");
  const navigacijaObserver = new IntersectionObserver(navigacijaCall, {
    root: cont,
    threshold: 0.5,
  });
  const linkai = document.querySelectorAll(".menu a");
  linkai.forEach((v) => {
    v.href = "#";
  });
  skaidres.forEach((v) => {
    navigacijaObserver.observe(v);
  });
}
updateLinks(1);
if ("IntersectionObserver" in window) {
  animacijaSetup();
  navigacijaSetup();
}
// var target = 0,
// uzsklanda = document.querySelector("#uzsklanda");
// function showModal(a) {
//   updateHistory("modal" + a);
//   uzsklanda.style.display = "block";
//   uzsklanda.classList.add("o-0");
//   target = document.querySelector("#uz" + a.toString());
//   target.style.display = "flex";
//   setTimeout(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//     skaidres.style.display = "none";
//     menu.style.display = "none";
//     modal = true;
//   }, 100);
// }
// function scrolling() {
//   var a = document.getElementById("cont");
//   // $(".skaidres").scrollTop();
//   // $(".skaidre").innerHeight();
//   document.querySelectorAll(".fade-in").forEach(function (el) {
//     0 >=
//       el.clientTop +
//         el.innerHeight -
//         document.querySelector(".skaidre").innerHeight &&
//       el.classList.add("atsirask");
//   });
//   b = a.scrollTop;
//   a = a.scrollHeight / 6;
//   if (!autoscroll) {
//     updateLinks(Math.round(b / a + 1));
//   }
window.slinkSkaidr = slinkSkaidr;
